import { render } from "./2_foot.vue?vue&type=template&id=64ee2175&scoped=true"
import script from "./2_foot.vue?vue&type=script&lang=js"
export * from "./2_foot.vue?vue&type=script&lang=js"

import "./2_foot.vue?vue&type=style&index=0&id=64ee2175&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ee2175"]])

export default __exports__